import  { api, apiMultipart } from "../../api/axios";

export const getAllTrips = async (params) => {
  let response = await api.get("/trips", { params });
  return response.data;
};

// parse Trips 

export const parseTrips = async (payload) => {
  let response = await apiMultipart.post("/trips/parse", payload);
  return response.data;
};
